import { render } from "./EmpresasForm.vue?vue&type=template&id=3a1b2d70"
import script from "./EmpresasForm.vue?vue&type=script&lang=js"
export * from "./EmpresasForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__